import React, { useEffect, useState } from "react";
import "./style.css";
import { useDispatch } from "react-redux";
import { UIColor } from "../../themes/theme";
import { AxiosCall, urls, AlertProps, __tenantid__ } from "../../utils";
import actions from "../../redux/actions";
import jwtDecode from "jwt-decode";
import axios from "axios";
import {
  Stack,
  Typography,
  Dialog,
  Chip,
  DialogTitle,
  DialogContent,
  Grid,
  Button,
  Autocomplete,
  TextField,
  IconButton,
} from "@mui/material";
import { AlertContext } from "../../context";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../router/routes";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import AppHeader from "../layout/appHeader";
import CloseIcon from "@material-ui/icons/Close";

var debouncing;

const ObservationReport = (props) => {
  const dispatch = useDispatch();
  const alert = useContext(AlertContext);
  const userInfo = localStorage.getItem("UserInfo");
  const decodedUserinfo = jwtDecode(userInfo);
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [cashierdatas, setCashierdatas] = useState({
    facility: [],
    startdate: "",
    enddate: "",
    user: [],
  });
  const [facilityNameData, setFacilityNameData] = useState([]);
  const [practitionerNameData, setPractitionerNameData] = useState([]);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [error, setError] = useState({});
  const { parent_id } = props;

  const setData = async (name, value) => {
    const updatedData = { ...cashierdatas };
    if (name === "startdate" || name === "enddate") {
      updatedData[name] = dayjs(value).format("YYYY-MM-DD");
    } else {
      updatedData[name] = value;
    }
    setCashierdatas(updatedData);
    if (
      updatedData?.facility &&
      updatedData?.startdate &&
      updatedData?.enddate
    ) {
      const startDate = updatedData?.startdate;
      const endDate = updatedData?.enddate;
      const facilityIdString =
        updatedData?.facility?.map((item) => item._id).join(",") || "";
      try {
        const response = await dispatch(
          actions.OBSEVATION_REPORT_PATIENT_DROPDOWN({
            facilityid: facilityIdString,
            startdate: startDate,
            enddate: endDate,
          })
        );
        setPractitionerNameData(response?.payload?.data);
      } catch (error) {}
    }
  };
  const GetPractID = (data) => {
    let list = [];

    for (let index in data) {
      const item = data[index];
      const datatemp = {
        value: item.patientName,
        _id: item.patientId,
      };

      list.push(datatemp);
    }
    return list;
  };
  const GetFacilityId = (data) => {
    let list = [];

    for (let index in data) {
      const item = data[index];
      const datatemp = {
        value: item.name,
        _id: item._id,
      };

      list.push(datatemp);
    }
    return list;
  };
  const validation = () => {
    let data = {
      facility: [],
      startdate: "",
      enddate: "",
      user: [],
    };
    let validation = {
      error: false,
    };

    Object.keys(data).forEach((v) => {
      if (v === "startdate" || v === "enddate") {
        if (cashierdatas[v] == null && cashierdatas[v] == undefined) {
          validation.error = true;
          validation[v] = true;
        } else {
          if (!dayjs(cashierdatas[v]).isValid()) {
            validation.error = true;
            validation[v] = true;
          } else {
            validation[v] = false;
          }
        }
      } else if (Array.isArray(data[v])) {
        if (!cashierdatas[v]?.length) {
          validation.error = true;
          validation[v] = true;
        } else {
          validation[v] = false;
        }
      }
    });
    setError(validation);
    return validation;
  };
  const dailogclose = () => {
    setOpen(false);
    navigate(AppRoutes.dashboard);
  };

  const HandleChangeForUser = (e, v) => {
    setCashierdatas({ ...cashierdatas, user: v || [] });
  };
  const ServcieSearch = (value) => {
    if (value) {
      clearTimeout(debouncing);
      debouncing = setTimeout(() => {
        dispatch(actions.REPORTS_FACILITY_DROPDOWN(value));
      }, 700);
    }
  };
  const UserSearch = (value) => {
    if (value) {
      clearTimeout(debouncing);
      debouncing = setTimeout(() => {
        dispatch(actions.OBSEVATION_REPORT_PATIENT_DROPDOWN(value));
      }, 700);
    }
  };

  const facilityName = async () => {
    const response = await dispatch(
      actions.REPORTS_FACILITY_DROPDOWN({
        facilityid: decodedUserinfo?.facilityid || "",
        tenantid: decodedUserinfo?.tenantid,
      })
    );
    setFacilityNameData(response?.payload?.data);
    const defaultFacility = response?.payload?.data.filter(
      (item) => item?._id === decodedUserinfo?.facilityid
    );
    setCashierdatas((prevState) => ({
      ...prevState,
      facility: [
        {
          value: defaultFacility?.[0]?.name,
          _id: defaultFacility?.[0]?._id,
        },
      ],
      startdate: dayjs().format("YYYY-MM-DD"),
      enddate: dayjs().format("YYYY-MM-DD"),
    }));
  };
  const loadPatientData = async () => {
    if (
      cashierdatas?.facility &&
      cashierdatas?.startdate &&
      cashierdatas?.enddate
    ) {
      const startDate = cashierdatas?.startdate;
      const endDate = cashierdatas?.enddate;
      const facilityIdString =
        cashierdatas?.facility?.map((item) => item._id).join(",") || "";
      try {
        const response = await dispatch(
          actions.OBSEVATION_REPORT_PATIENT_DROPDOWN({
            facilityid: facilityIdString,
            startdate: startDate,
            enddate: endDate,
          })
        );
        setPractitionerNameData(response?.payload?.data);
      } catch (error) {}
    }
  };
  useEffect(() => {
    facilityName();
  }, []);
  useEffect(() => {
    loadPatientData();
  }, [cashierdatas?.facility, cashierdatas?.startdate, cashierdatas?.enddate]);

  const generateAndOpenJasperReport = async () => {
    const getEpochTime = (date) => Math.floor(date.getTime() / 1000);
    let JwtToken = localStorage.getItem("JwtToken");
    let header = { JwtToken: JwtToken };

    const startDate = new Date(cashierdatas?.startdate);
    startDate.setHours(0, 0, 0, 0);
    const startEpochTime = getEpochTime(startDate);

    const endDate = new Date(cashierdatas?.enddate);
    endDate.setHours(23, 59, 59, 999);
    const endEpochTime = getEpochTime(endDate);

    const startdate = dayjs(cashierdatas?.startdate);
    const enddate = dayjs(cashierdatas?.enddate);
    if (enddate < startdate) {
      alert.setSnack({
        open: true,
        severity: AlertProps.severity.error,
        msg: "End date should be after the start date",
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.right,
      });
      return;
    }
    let valid = validation();
    if (valid.error) {
      alert?.setSnack({
        open: true,
        severity: AlertProps.severity.warning,
        msg: "Please fill mandatory fields",
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.center,
        tone: true,
      });
      return;
    } else {
      const payload = {
        reportid: "5dfe282c-e35b-4f56-96b4-2ccb804d71ad",
        inputparams: {
          "@facilityid":
            cashierdatas?.facility?.map((item) => item._id).join(",") ?? "",
          "@startdate": startEpochTime,
          "@enddate": endEpochTime,
          "@patientid":
            cashierdatas?.user?.map((item) => item?._id).join(",") ?? "",
        },

        result: [],
      };
      AxiosCall("post", urls.jasperReport, payload, header).then(
        async (res) => {
          if (res?.downloadUrl) {
            const response = await axios.get(res?.downloadUrl, {
              method: "GET",
              responseType: "blob",
            });
            const pdfBlob = new Blob([response.data], {
              type: "application/pdf",
            });
            const pdfDataUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfDataUrl, "_blank");
            props?.handleModalClose();
          } else {
            alert?.setSnack({
              open: true,
              severity: AlertProps.severity.error,
              msg: "There is no report available.",
              vertical: AlertProps.vertical.top,
              horizontal: AlertProps.horizontal.center,
              tone: true,
            });
            props?.handleModalClose();
          }
        }
      );
    }
    setOpen(false);
    navigate(AppRoutes.dashboard);
  };
  useEffect(() => {
    if (downloadUrl) {
      const downloadLink = document.createElement("a");
      downloadLink.href = downloadUrl;
      downloadLink.target = "_blank";
      downloadLink.download = "report.pdf";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }, [downloadUrl]);
  const helperTextMsg = "This field is required!";
  const errorMessage = React.useMemo(() => {
    if (error?.startdate || error?.enddate) {
      return "Please select a date";
    }
  }, [error]);
  return (
    <div>
      {/* <Grid>
        <AppHeader />
      </Grid>
      <Dialog
        maxWidth="xl"
        fullWidth
        open={open}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DialogTitle>
          <Typography style={{ fontSize: "18px" }}>
            Observation Report - Daily/Weekly/Monthly
          </Typography>
        </DialogTitle>
        <DialogContent dividers> */}
          <div
            style={{
              backgroundColor: "#fff",
              outline: "none",
              width: 500,
              paddingLeft: "15px",
            }}
          >
              <IconButton
            aria-label="close"
            onClick={props?.handleModalClose}
            style={{ position: "absolute", right: 0, top: 0 }}
          >
            <CloseIcon />
          </IconButton>
            <Grid container spacing={3}>
            <Grid
                item
                id={`${parent_id}referral_parent_Referring_from_Facility_col`}
                md={12}
                lg={12}
                sm={12}
                xs={12}
                className="no-padding-left"
                inLineStyles={{ padding: 10 }}
              >
                <Typography variant="h5">Observation Report - Daily/Weekly/Monthly</Typography>
              </Grid>
              <Grid
                item
                id={`${parent_id}referral_parent_Referring_from_Facility_col`}
                md={12}
                lg={12}
                sm={12}
                xs={12}
                className="no-padding-left"
              >
                <div>
                  <Autocomplete
                    multiple
                    id="tags-filled"
                    options={GetFacilityId(facilityNameData) ?? []}
                    getOptionLabel={(option) => option?.value ?? ""}
                    limitTags={2}
                    hoverColor={UIColor.primaryColor.color}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          variant="outlined"
                          label={option?.value}
                          {...getTagProps({ index })}
                          size="small"
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        required={true}
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder="search facility"
                        label="Facility"
                        hoverColor={UIColor.primaryColor.color}
                        sx={{
                          "& .MuiAutocomplete-inputRoot": {
                            borderRadius: "8px",
                            border: "1px  #E0E0E0",
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                        }}
                        error={error?.facility}
                        helperText={error?.facility ? helperTextMsg : ""}
                      />
                    )}
                    onChange={(event, newValue) =>
                      setData("facility", newValue)
                    }
                    value={cashierdatas?.facility || []}
                    onInputChange={(e) => {
                      ServcieSearch(e.target.value);
                    }}
                  />
                </div>
              </Grid>
              <Grid
                item
                container
                spacing={2}
                id={`${parent_id}referral_parent_Date_of_Referral_In_col`}
                md={12}
                lg={12}
                sm={12}
                xs={12}
                className="no-padding-left"
              >
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Start Date"
                      value={
                        cashierdatas?.startdate
                          ? dayjs(cashierdatas?.startdate)
                          : dayjs(new Date())
                      }
                      onChange={(e, v) => setData("startdate", e)}
                      onError={error?.startdate}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderRadius: "8px",
                          },
                        },
                      }}
                      slotProps={{
                        textField: {
                          helperText: errorMessage,
                          error: error?.startdate ? true : false,
                          size: "small",
                          required: true,
                          fullWidth: true,
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="End Date"
                      value={
                        cashierdatas?.enddate
                          ? dayjs(cashierdatas?.enddate)
                          : dayjs(new Date())
                      }
                      onChange={(e) => setData("enddate", e)}
                      onError={error?.enddate}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderRadius: "8px",
                          },
                        },
                      }}
                      slotProps={{
                        textField: {
                          helperText: errorMessage,
                          error: error?.enddate ? true : false,
                          size: "small",
                          required: true,
                          fullWidth: true,
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
              <Grid
                item
                id={`${parent_id}referral_parent_Referring_from_Facility_col`}
                md={12}
                lg={12}
                sm={12}
                xs={12}
                className="no-padding-left"
              >
                <div>
                  <Autocomplete
                    multiple
                    id="tags-filled"
                    options={GetPractID(practitionerNameData) ?? []}
                    getOptionLabel={(option) => option?.value ?? ""}
                    limitTags={2}
                    hoverColor={UIColor.primaryColor.color}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          variant="outlined"
                          label={option?.value}
                          {...getTagProps({ index })}
                          size="small"
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        required={true}
                        placeholder="search patient"
                        hoverColor={UIColor.primaryColor.color}
                        style={{ paddingBottom: "20px" }}
                        sx={{
                          "& .MuiAutocomplete-inputRoot": {
                            borderRadius: "8px",
                            border: "1px  #E0E0E0",
                          },
                        }}
                        label="Patient"
                        InputProps={{
                          ...params.InputProps,
                        }}
                        error={error?.user}
                        helperText={error?.user ? helperTextMsg : ""}
                      />
                    )}
                    onChange={(e, v) => {
                      HandleChangeForUser(e, v);
                    }}
                    value={cashierdatas?.user || []}
                    onInputChange={(e) => {
                      UserSearch(e.target.value);
                    }}
                  />
                </div>
              </Grid>
            </Grid>

            <Stack
              container
              md={12}
              lg={12}
              spacing={3}
              direction="row"
              justifyContent="center"
            >
              <Button
                variant="outlined"
                size="medium"
                style={{
                  color: UIColor.primaryColor.color,
                  borderColor: UIColor.primaryColor.color,
                }}
                onClick={props?.handleModalClose}
              >
                Cancel
              </Button>

              <Button
                size="medium"
                style={{
                  color: "#fff",
                  background: UIColor.primaryColor.color,
                }}
                variant="contained"
                onClick={() => generateAndOpenJasperReport()}
              >
                Submit
              </Button>
            </Stack>
          </div>
        {/* </DialogContent>
      </Dialog> */}
    </div>
  );
};

export default ObservationReport;
